module.exports = __webpack_public_path__ + "img/location-button.88d7677f.svg";